import axios from 'axios'
import { axiosResponseErrorInterceptor } from './axios-helpers'

class HttpClient {
  constructor(headers) {
    this.baseUrl = import.meta.env.VITE_BASE_URL
    this.headers = headers
  }

  shippingInstance = () => {
    const instance = axios.create({
      baseURL: `${this.baseUrl}${import.meta.env.VITE_API_SHIPPING}`,
      timeout: import.meta.env.VITE_API_TIMEOUT,
      headers: this.headers || null,
    })
    instance.interceptors.response.use((response) => response, axiosResponseErrorInterceptor)
    return instance
  }

  reportingInstance = () => {
    const instance = axios.create({
      baseURL: `${this.baseUrl}${import.meta.env.VITE_API_REPORTING}`,
      timeout: import.meta.env.VITE_API_TIMEOUT,
      headers: this.headers || null,
    })
    instance.interceptors.response.use((response) => response, axiosResponseErrorInterceptor)
    return instance
  }

  inventoryInstance = () => {
    const instance = axios.create({
      baseURL: `${this.baseUrl}${import.meta.env.VITE_API_INVENTORY}`,
      timeout: import.meta.env.VITE_API_TIMEOUT,
      headers: this.headers || null,
    })
    instance.interceptors.response.use((response) => response, axiosResponseErrorInterceptor)
    return instance
  }

  invoiceInstance = () => {
    const instance = axios.create({
      baseURL: `${this.baseUrl}${import.meta.env.VITE_API_INVOICE}`,
      timeout: import.meta.env.VITE_API_TIMEOUT,
      headers: this.headers || null,
    })
    instance.interceptors.response.use((response) => response, axiosResponseErrorInterceptor)
    return instance
  }

  documentInstance = () => {
    const instance = axios.create({
      baseURL: `${this.baseUrl}${import.meta.env.VITE_API_UPLOAD}`,
      timeout: import.meta.env.VITE_API_TIMEOUT,
      headers: this.headers || null,
    })
    instance.interceptors.response.use((response) => response, axiosResponseErrorInterceptor)
    return instance
  }

  userInstance = () => {
    /* If headers are empty, set headers */
    const instance = axios.create({
      baseURL: `${this.baseUrl}${import.meta.env.VITE_API_USER}`,
      timeout: import.meta.env.VITE_API_TIMEOUT,
      headers: this.headers || null,
    })
    instance.interceptors.response.use((response) => response, axiosResponseErrorInterceptor)
    return instance
  }
}

export default HttpClient
